import React from 'react'
import PhotoCard from '../PhotoCard'

const PhotoListas = ({ header, list }) => {
  // console.log('list', list)
  return (
    <div>
      <div className="listas-home-block__title">{header}</div>
      <div className="listas-home-block__list">
        {list &&
          list.map((item, index) => (
            <div
              key={index}
              className="px-2 py-1 -mx-3 transition duration-500 ease-in-out sm:-mx-8 listas-home-block__list border-b-1 first:border-t-1 last:border-b-0 hover:bg-gray-400">
              <PhotoCard {...item} />
            </div>
          ))}
      </div>
    </div>
  )
}

export default PhotoListas
